import React, { useState } from "react";
import classNames from "classnames";
import { useLocation } from "react-router-dom";

import { Loader } from "../../components/utilities/loader";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/alert";
import { formatUrl } from "../../helpers/parse-url";
import { loadLessonById, questionUpdate } from "../../services/documents/documents.context";
import { QuestionUnit } from "../../components/tutorials/question-unit";
import VideoThumb from "../../components/utilities/video";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";



export const UpdateParts = () => {

    const { token } = useAuth();

    const { state } = useLocation();
    const {tutorial} = state;
   

    const  tuId = tutorial?._id; 

    const [loadedTut, setLoadedTut] = useState();

    const [qEdit, setQEdit] = useState(null);
   

 
    const quest = loadedTut?.evaluation?.questions;

    const [pageAlert, setPageAlert] = useState();
    const [loading, setLoading] = useState(false);

 

    


    const tutorialFromServer = async (id) => {
        const data = await loadLessonById(id);
        //console.log({data: data?.evaluation?.questions})
        setLoadedTut(data);
    }

    React.useEffect(() => {
        (async() =>{
            await tutorialFromServer(tuId)
        })();
        console.log(qEdit)
    },[tuId,qEdit]);


    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={"Update tutorial"} />
            {loading && <Loader />}
            {pageAlert &&
                <AppAlert
                    caption={pageAlert?.caption}
                    message={pageAlert?.message}
                    accept={"OK"}
                    acceptAction={() =>setPageAlert()}
                />
            }
            <div className="add-page">
                <div className="add-container">
                    <VideoThumb src={formatUrl(tutorial.video)} />
                    {qEdit &&
                    <div className="add-form-container">
                        <form className="add-form">
                            <div className="n-frm-cont">
                                <span className="n-input-cap">Question:</span>
                                <input 
                                    className="n-frm-inpt"
                                    name="question"
                                    value={qEdit?.question}
                                    onChange={(e) => {
                                        setQEdit((q) => ({...q, question: e.target.value}))
                                    }} 
                                />
                            </div>
                            <div className="opt-caption">options</div>
                            <div className="option-box">
                                <div className="n-frm-cont">
                                    <span className="n-input-cap">A:</span>
                                    <input 
                                        className="n-frm-inpt"
                                        name="question"
                                        value={qEdit.options[0]}
                                        onChange={(e) => {
                                            let tmp = qEdit.options;
                                            tmp[0] = e.target.value;
                                            setQEdit((q) => ({...q,options:tmp}));
                                        }} 
                                    />
                                </div>
                                <div className="n-frm-cont">
                                    <span className="n-input-cap">B:</span>
                                    <input 
                                        className="n-frm-inpt"
                                        name="question"
                                        value={qEdit.options[1]}
                                        onChange={(e) => {
                                            let tmp = qEdit.options;
                                            tmp[1] = e.target.value;
                                            setQEdit((q) => ({...q,options:tmp}));
                                        }} 
                                    />
                                </div>
                                <div className="n-frm-cont">
                                    <span className="n-input-cap">C:</span>
                                    <input 
                                        className="n-frm-inpt"
                                        name="question"
                                        value={qEdit.options[2]}
                                        onChange={(e) => {
                                            let tmp = qEdit.options;
                                            tmp[2] = e.target.value;
                                            setQEdit((q) => ({...q,options:tmp}));
                                        }} 
                                    />
                                </div>
                                <div className="n-frm-cont">
                                    <span className="n-input-cap">D:</span>
                                    <input 
                                        className="n-frm-inpt"
                                        name="question"
                                        value={qEdit.options[3]}
                                        onChange={(e) => {
                                            let tmp = qEdit.options;
                                            tmp[3] = e.target.value;
                                            setQEdit((q) => ({...q,options:tmp}));
                                        }} 
                                    />
                                </div>

                            </div>
                            <div className="n-frm-cont">
                                <span className="n-input-cap">Answer:</span>
                                <input 
                                    className="n-frm-inpt"
                                    name="question"
                                    value={qEdit?.answer}
                                    onChange={(e) => {
                                        setQEdit((q) => ({...q, answer: e.target.value}))
                                    }} 
                                />
                            </div>
                            <div className="frm-button-box">
                                <button 
                                    className={classNames("frm-button",{dis: false})}
                                    onClick={
                                        async (e) => {
                                            e.preventDefault();
                                            setLoading(true);
                                            const res = await questionUpdate(token, qEdit, qEdit?._id);
                                            setLoading(false);
                                            if (res?.error){
                                                setPageAlert({message: res?.error, caption: "Error"})
                                            }
                                            setPageAlert({message: res?.message, caption: 'Success!'});
                                            if (!res?.error) {
                                                window.location.reload();
                                            }
                                    }}
                                    disabled={qEdit.options.length < 4}
                                >
                                    Update question 
                                </button>
                            </div>
                        </form>
                    </div>}
                </div>
                <div className="questions-cont">
                    { quest?.map((question,i) => {
                        return (
                            <div className="unit-update">
                                <QuestionUnit
                                    questionData={question}
                                    submited={true}
                                    indx={i}
                                    key={i}
                                />
                                <div className="update-option-btns">
                                    <button className="u-o-btn" onClick={() => setQEdit(() => ({...question}))}>
                                        <FontAwesomeIcon icon={faEdit} />
                                        Update
                                    </button>
                                    <button className="u-o-btn">
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                        Delete
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}